// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9e2e5296","455":"45cac851","977":"af97a099"}[chunkId] + ".chunk.js";
};